import { FlagState } from './types';
/**
 * All allowed feature flags and their default values
 */
export const features = {
    feature_pleditor_sandbox: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_pleditor_dev_banner: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_customer_success: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_plai_quotes: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_create_company: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_orca_editor: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_action_centre: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_agent_chat_model_picker: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_agent_sidebar: {
        value: FlagState.DISABLED,
        force: false,
    },
};
export const featureFlagKeys = Object.keys(features);
